import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_URL, AuthHttpHandleService } from '@contler/utils';

import { Admin, CreatAdministratorRequest } from '../models';

@Injectable({
  providedIn: 'root',
})
export class AdminToolsService {
  private http: HttpClient;
  private authHandle = inject(AuthHttpHandleService);
  private apiUrl = inject(API_URL);

  constructor() {
    this.http = new HttpClient(this.authHandle);
  }

  createAdmin(request: CreatAdministratorRequest) {
    const url = new URL('admin-tools/creat-admins', this.apiUrl);
    return this.http.post(url.toString(), request);
  }

  updateAdmin(request: Admin) {
    const url = new URL('admin-tools/update-admin', this.apiUrl);
    return this.http.put(url.toString(), request);
  }

  deleteAdmin(request: Admin) {
    const url = new URL('admin-tools/delete-admin/' + request.uid, this.apiUrl);
    return this.http.delete(url.toString());
  }

  getAdmins() {
    const url = new URL('admin-tools/creat-admins', this.apiUrl);
    return this.http.get<Admin[]>(url.toString());
  }
}
